/*

	Extensions of core JavaScript objects
	Some methods are natively supported in certain browsers so check for existsence first

	- Sg

*/

/* BEGIN: Boolean */

	Boolean.prototype.handle = function(a,b){
		return a.apply(b?b:window,[this.valueOf()]);
	};

/* END: Boolean */


/* BEGIN: Strings */

	if(!String.prototype.trim){
		String.prototype.trim = function(){
			return this.replace(/^[\s]+/g,"").replace(/[\s]+$/g,"");
		};
	}

	if(!String.prototype.left){
		String.prototype.left = function(cnt){
			return this.substr(0,cnt);
		};
	}

	if(!String.prototype.right){
		String.prototype.right = function(cnt){
			return this.substr(this.length - cnt,this.length);
		};
	}

	String.prototype.elipses = function(cnt){
		var _str = this;

		if(_str.length < cnt){
			return _str.toString();
		}

		return _str.left(cnt) + "...";
	}

	if(!String.prototype.concat){
		String.prototype.concat = function(){
			var _arr = [this.valueOf()],i = 0;

			while(i < arguments.length){
				_arr.push(arguments[i]);
			}

			return _arr.join("");
		}
	}

	String.prototype.toLabel = function(){
		var newStr = "";
		var chars = (this.left(1).toUpperCase() + ((this.length > 1)?this.right(this.length - 1):"")).split("");

		for(var i=0,len = chars.length;i < len;i++){
			newStr += ((i > 0 && chars[i].replace(/[A-Z]+/,"") == "")?" ":"") + chars[i];
		}

		return newStr;
	}

  String.prototype.toProperCase = function() {
    const words = this.split(' ');
    for(let i = 0; i < words.length; i++) {
      words[i] = words[i].left(1).toUpperCase() + words[i].right(words[i].length - 1).toLowerCase();
    }
    return words.join(' ');
  }

	String.prototype.parsePhone = function(){
		var str = this;
			str = str.replace(/\D/ig,"");

		if(str.length < 10 || isNaN(str)){
			return "";
		}

		return "(" + str.substr(0,3) + ") " + str.substr(3,3) + "-" + str.substr(6,4) + ((str.length > 10)?(" ext. " + str.substr(10,str.length - 10)):"");
	};

	String.prototype.isPhone = function(){
		return (this.parsePhone() != "");
	};

	String.prototype.isEmail = function(){
		if(/^[_a-zA-Z0-9-']+(\.[_a-zA-Z0-9-']+)*@[a-zA-Z0-9-']+(\.[a-z0-9-']+)*\.(([a-z]{2,3})|(aero|coop|info|museum|name))$/.test(this) || this.trim() == ""){
			return true;
		}
		else{
			return false;
		}
	};

	String.prototype.px = function(a){
		var str = this.valueOf(),
			mult = typeof a === "undefined"?1:a,
			num = str.val("$");

		if(str.right(1) === "%"){
			num = (num / 100) * mult;
		}

		return num.toString() + "px";
	};

	String.prototype.fraction2Number = function(){
		var str = this.valueOf(),
			parts = str.split(' '),
			num = 0;

		parts.forEach(
			function(p){
				if(p.indexOf('/') !== -1){
					var numerator = p.split('/')[0].val('$'), denominator = p.split('/')[1].val('$');
					num += numerator/denominator;
				}
				else {
					num += p.val('$');
				}
			}
		);

		return num;
	}

	String.prototype.val = function(a,b){
		var addTo = typeof a !== "undefined"?a:0,
			append = typeof b !== "undefined"?b:null,
			_str = this.valueOf(),
			_neg,
			_wh,
			_dec;

		// Dollar sign means parse out ALL non-numerics (i.e. $2,000.00 returns 2000)
		if(addTo === "$"){
			// Minus signs will get stripped so handle now
			if(_str.indexOf('/') !== -1){
				_str = _str.fraction2Number().toString();
			}
			_neg = (_str.split("-").length === 2 && _str.split("-")[1].val("$") > 0)?-1:1;
			_wh = _str.split(".")[0].replace(/\D/ig,"");
			_dec = (_str.split(".").length > 1)?_str.split(".")[1].replace(/\D/ig,""):"";
			res = (_wh + ((_dec != "")?".":"") + _dec).val() * _neg;
		}
		else if(_str.right(1) === "%"){
			res = (_str.val("$") / 100) * addTo;
		}
		else if(isNaN(_str) || _str.trim() === ""){
			res = 0;
		}
		else {
			res = parseFloat(_str);
		}

		if(!isNaN(addTo) && addTo !== 0 && typeof res === "number" && _str.right(1) !== "%"){
			res = res + addTo.val();
		}

		// Appending a string would be used for DOM type metric calculations (i.e. "75%".val(250,"px"))
		if(append !== null){
			res = res.toString() + append;
		}

		if(typeof res === "number"){
			res = res.fixPrecision();
		}

		return res;
	}

	String.prototype.isBetween = function(l,h){
		return (this.val() >= l.val() && this.val() <= h.val());
	}

	String.prototype.repeat = function(n){
		var str = "";

		while(n > 0){
			str += this;
			--n;
		}

		return str;
	}

	String.prototype.padZeros = function(n){
		var str = this.toString();

		if(str.length < n){
			var str = ("0").repeat(n - str.length) + str;
		}

		return str;
	};

	String.prototype.hex2Rgb = function(){
		var str = this.replace(/#/,"");

		if(str.length == 3){
			str = [parseInt(str.substr(0,1) + str.substr(0,1),16),parseInt(str.substr(1,1) + str.substr(1,1),16),parseInt(str.substr(2,1) + str.substr(2,1),16)];
		}
		else{
			str = [parseInt(str.substr(0,2),16),parseInt(str.substr(2,2),16),parseInt(str.substr(4,2),16)];
		}

		return str;
	};

	String.prototype.append = function(str){
		return [this.toString(),str].join("");
	};

	String.prototype.prepend = function(str){
		return [str,this.toString()].join("");
	};

	String.prototype.versionValue = function(){
		var parts = this.split(".").reverse(),
			version = 0;

		parts.forEach(
			function(v,i){
				version += v.val() * Math.pow(10,i);
			}
		);

		return version;
	};

	String.prototype.jq = function(){
		return this.replace( /(:|\.|\[|\]|,)/g, "\\$1" );
	};

/* END: String */

/* BEGIN: Array */

	Array.fromArguments = function(origArgs){
		var args = [],i,len;

		for(i=0,len=origArgs.length;i < len;i++){
			args.push(origArgs[i]);
		}

		return args;
	}

	Array.prototype.Sort = function(){
		var dir = (arguments.length > 0)?((arguments[0].toLowerCase().indexOf("a")>-1)?"ASC":"DESC"):"ASC";
		var o = {
			f : function(a,b){
				var A = a.toString().toLowerCase();
				var B = b.toString().toLowerCase();
				var C = (dir === "ASC")?-1:1;
				var D = (dir === "ASC")?1:-1;
				// Sort numerically
				if((A - B).toString() !== "NaN") return (C === -1)?A-B:B-A;
				// Sort alphabetically
				if (A < B) return C;
				if (A > B) return D;
				return 0;
			}
		};

		return this.sort(o.f);
	}

	Array.prototype.SortByAttribute = function(attr,dir,dataType){
		var updn = dir === undefined?"ASC":dir;

		return this.sort(
			function(obj1,obj2){
				var val1 = obj1[attr] === undefined?"":obj1[attr].toString().toLowerCase(),
					val2 = obj2[attr] === undefined?"":obj2[attr].toString().toLowerCase(),
					retLT = (updn === "ASC")?-1:1,
					retGT = (updn === "ASC")?1:-1;

				// Convert certain data types if specified
				if(dataType === "date"){
					val1 = new Date(val1).getTime();
					val2 = new Date(val2).getTime();
				}
                else if(dataType === "time") {
					// time expected to come in as only the time portion.. add Jan 1, 1970 in front of it to make it valid date
					val1 = new Date(`1970-01-01 ${val1}`).getTime();
					val2 = new Date(`1970-01-01 ${val2}`).getTime();
				}

				// Sort numerically
				if(typeof obj1[attr] === "number" && typeof obj2[attr] === "number") return (retLT === -1)?obj1[attr]-obj2[attr]:obj2[attr]-obj1[attr];
				// Sort alphabetically
				if (val1 < val2) return retLT;
				if (val1 > val2) return retGT;
				return 0;
			}
		);
	};

	if(!Array.isArray){
		Array.isArray = function(o){
			return o.constructor === Array;
		}
	}

	/* Sets an array of objects */
	Array.prototype.setObject = function(arr){
		var arr = arr || this;
		arr.forEach(function(itm,idx){
			// If it's a setter method
			if(itm.set){
				itm.set.apply(itm.scope || sc || window,[itm.value]);
			}
			// If it's a value assignment
			else if(itm.obj){
				var _obj = itm.obj;
				var _props = itm.prop.split(".");
					_props.forEach(function(prop,pidx){
					// If we're on the last chain in the object, set it
					if(pidx === _props.length - 1){
						_obj[prop] = itm.value;
					}
					else{
						_obj = _obj[prop];
					}
				});
			}
		});
	};

	/* Allows an array of objects to be set off at a later time
		Example: [
			{obj:$("foo"),prop:"style.display",value:"none"},
			{set:document.body.removeChild,scope:document.body,value:$("bazz")}
		].After(1000)
	*/
	Array.prototype.After = function(tm,sc){
		var _arr = this;

		return _arr.setObject.After(tm,[_arr],sc);
	};

	/* Allows an array of objects to iterate at a given interval
		Example: [
			{obj:$("foo"),prop:"style.display",value:"none"},
			{set:document.body.removeChild,scope:document.body,value:$("bazz")}
		].Every(30000)
	*/
	Array.prototype.Every = function(tm,sc,mx){
		var _arr = this;

		return _arr.setObject.Every(tm,[],sc,mx);
	};

	Array.prototype.removeDups = function(){
		var newArr = [];

		this.forEach(
			function(o){
				if(newArr.indexOf(o) === -1){
					newArr.push(o);
				}
			}
		)

		return newArr;
	};

/* END: Array */

/* BEGIN: Number */

	Number.prototype.px = function(a){
		return this.toString().px(a);
	};

	Number.prototype.fixPrecision = function(){
		return parseFloat(this.valueOf().toPrecision(10));
	};

	Number.prototype.val = function(a,b){
		var addTo = typeof a !== "undefined"?a:0,
			append = typeof b !== "undefined"?b:null,
			num = this.valueOf(),
			_neg,_wh,_dec;

		if(isNaN(addTo) || addTo === ""){
			addTo = 0;
		}
		else if(typeof addTo !== "number" && !isNaN(addTo)){
			addTo = parseFloat(addTo);
		}
		else if(typeof addTo !== "number"){
			addTo = 0;
		}

		if(addTo !== 0){
			num = num + addTo;
		}

		return num.fixPrecision();
	}

	Number.prototype.isBetween = function(l,h){
		return this.toString().isBetween(l,h);
	}

	Number.prototype.toRad = function() {
		return this.valueOf() * Math.PI / 180;
	}

	Number.prototype.repeat = function(n){
		return this.toString().repeat(n);
	}

	Number.prototype.padZeros = function(n){
		return this.toString().padZeros(n);
	};

/* END: Number */

/* BEGIN: Math */

	// Uses Math.round built-in method with an additional argument for a specific number of decimals
	Math.Round = function (n,d){
		var d = this.pow(10,d),
			n = n * d;
		n = this.round(n);
		n = n / d;
		return n;
	};

	Math.getGEODistance = function(lat1,lon1,lat2,lon2){
		var R = 6371,
			dLat = (lat2.val() - lat1.val()).toRad(),
			dLon = (lon2.val() - lon1.val()).toRad(),
			lat1 = lat1.val().toRad(),
			lat2 = lat2.val().toRad(),
			a = this.sin(dLat/2) * this.sin(dLat/2) + this.sin(dLon/2) * this.sin(dLon/2) * this.cos(lat1) * this.cos(lat2),
			c = 2 * this.atan2(this.sqrt(a), this.sqrt(1-a)),
			d = R * c;

		return d * 0.621371192; // multiply by miles
	};

/* END: Math */

/* BEGIN: Date */

	Date.prototype.SQLFormat = function(){
		return this.getFullYear().toString() + "-" + (this.getMonth() + 1).toString() + "-" + this.getDate().toString() + " " + this.getHours().toString() + ":" + this.getMinutes().toString().padZeros(2) + ":" + this.getSeconds().toString().padZeros(2) + "." + this.getMilliseconds().toString();
	};

	Date.prototype.H5Format = function(){
		return this.getFullYear().toString() + "-" + (this.getMonth() + 1).toString().padZeros(2) + "-" + this.getDate().toString().padZeros(2);
	};

	Date.prototype.getUTCTime = function(){
		return new Date(
			this.getUTCFullYear(),
			this.getUTCMonth(),
			this.getUTCDate(),
			this.getUTCHours(),
			this.getUTCMinutes(),
			this.getUTCSeconds()
		).getTime();
	};

	// From http://stackoverflow.com/a/14242553
	Date.prototype.setISO8601 = function (string) {
	    var regexp = "([0-9]{4})(-([0-9]{2})(-([0-9]{2})" +
	        "(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?" +
	        "(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?";
	    var d = string.match(new RegExp(regexp));

	    var offset = 0;
	    var date = new Date(d[1], 0, 1);

	    if (d[3]) { date.setMonth(d[3] - 1); }
	    if (d[5]) { date.setDate(d[5]); }
	    if (d[7]) { date.setHours(d[7]); }
	    if (d[8]) { date.setMinutes(d[8]); }
	    if (d[10]) { date.setSeconds(d[10]); }
	    if (d[12]) { date.setMilliseconds(Number("0." + d[12]) * 1000); }
	    if (d[14]) {
	        offset = (Number(d[16]) * 60) + Number(d[17]);
	        offset *= ((d[15] == '-') ? 1 : -1);
	    }

	    offset -= date.getTimezoneOffset();
	    time = (Number(date) + (offset * 60 * 1000));
	    this.setTime(Number(time));
	};

/* END: Date */

/* BEGIN: JSON */

	JSON.clone = function(obj){
		var newObj = JSON.parse(JSON.stringify(obj));

		function cloneFunctions(src,targ) {
			if (src === null || typeof src !== "object") {
				return;
			}

			for (var key in src) {
				if(src.hasOwnProperty(key) && typeof src[key] === "object"){
					cloneFunctions(src[key],targ[key]);
				}
				else if(src.hasOwnProperty(key) && typeof src[key] === "function"){
					targ[key] = src[key];
				}
			}
		}
		cloneFunctions(obj,newObj);

		return newObj;
	};

	JSON.toURL = function(o){
		var str = [],
			key;
		for(key in o){
			if(o.hasOwnProperty(key)){
				str.push(key + "=" + encodeURIComponent(o[key]));
			}
		}
		return str.join("&");
	};

	JSON.fromURL = function(str){
		var str = (str.left(1) == "?")?str.right(str.length - 1):str,
			obj = {};
		try{
			if(str.trim() != ""){
				for(var i=0;i < str.split("&").length;i++){
					var thisEl = str.split("&")[i];
					obj[thisEl.split("=")[0]] = decodeURIComponent(thisEl.split("=")[1] || "");
				}
			}

			return obj;
		}
		catch(e){
			return {};
		}
	};

	JSON.tryParse = function(str){
		try {
			return JSON.parse(str);
		}
		catch(e) {
			return {
				JSON_PARSE_ERROR : true
			};
		}
	};

	/**
	 * Pass in a json string and parse it to a javascript object, but if it fails instead of throwing 
	 * an error return a defaultVal value instead. If a default isn't provided an empty {} object will be
	 * returned.
	 * 
	 * @param {string} jsonStr input json text string
	 * @param {*} defaultVal default that will be used if json is invalid
	 */
	JSON.safeParse = function(jsonStr, defaultVal) {
		if( typeof defaultVal === "undefined" ) {
			defaultVal = {};
		}
		// just incase the value passed in is already an object, just return it
		// instead of returning the default value
		if( typeof jsonStr === "object" && jsonStr !== null ) {
			return jsonStr;
		}
		// if the input couldn't possibly parse return the default value
		else if( typeof jsonStr !== "string" || jsonStr === null ) {
			return defaultVal;
		}
		// trim the input string, if its empty return the default to avoid the try/catch & parse
		jsonStr = jsonStr.trim();
		if( jsonStr === '' ) {
			return defaultVal;
		}
		try {
			return JSON.parse(jsonStr);
		}
		catch(e) {
			// console.log( `safeParse had an error: ${e.message}` );
			return defaultVal;
		}
	};


	/**
	 * Check if a json string is valid by checking its type and parsing it
	 * fully without exception.
	 * 
	 * Note if you use this function and then use JSON.parse() right after you
	 * should consider using safeParse() instead to avoid parsing the input twice.
	 * 
	 * @param {string} jsonStr input json text string
	 */
	JSON.isJSON = function(jsonStr) {
		/*
			NOTE:
				null is a data type of object so we need to check for it explicitly.
				numbers, booleans and undefined execute JSON.parse successfully
		*/
		if (typeof jsonStr === "object" && jsonStr !== null) {
			return true;
		}
		else if(['number','boolean','undefined'].indexOf(typeof jsonStr) !== -1){
			return false;
		}
	
		/*
			NOTE:
				Try parsing the string.  If it returns a proper object that is NOT null, we're good to go
		*/
		try {
			jsonStr = JSON.parse(jsonStr.trim());
			return typeof jsonStr === 'object' && jsonStr !== null;
		} catch (e) {
			// console.log( `isJSON had an error: ${e.message}` );
			return false;
		}
	};

	/**
	 * Pass in a json string and parse it to a javascript object, but if it fails instead of throwing
	 * an error return a defaultVal value instead. If a default isn't provided an empty {} object will be
	 * returned.
	 *
	 * @param {string} jsonStr input json text string
	 * @param {*} defaultVal default that will be used if json is invalid
	 */
	JSON.safeParse = function(jsonStr, defaultVal) {
		if( typeof defaultVal === "undefined" ) {
			defaultVal = {};
		}
		// just incase the value passed in is already an object, just return it
		// instead of returning the default value
		if( typeof jsonStr === "object" && jsonStr !== null ) {
			return jsonStr;
		}
		// if the input couldn't possibly parse return the default value
		else if( typeof jsonStr !== "string" || jsonStr === null ) {
			return defaultVal;
		}
		// trim the input string, if its empty return the default to avoid the try/catch & parse
		jsonStr = jsonStr.trim();
		if( jsonStr === '' ) {
			return defaultVal;
		}
		try {
			return JSON.parse(jsonStr);
		}
		catch(e) {
			// console.log( `safeParse had an error: ${e.message}` );
			return defaultVal;
		}
	}


	/**
	 * Check if a json string is valid by checking its type and parsing it
	 * fully without exception.
	 *
	 * Note if you use this function and then use JSON.parse() right after you
	 * should consider using safeParse() instead to avoid parsing the input twice.
	 *
	 * @param {string} jsonStr input json text string
	 */
	JSON.isJSON = function(jsonStr) {
		/*
			NOTE:
				null is a data type of object so we need to check for it explicitly.
				numbers, booleans and undefined execute JSON.parse successfully
		*/
		if (typeof jsonStr === "object" && jsonStr !== null) {
			return true;
		}
		else if(['number','boolean','undefined'].indexOf(typeof jsonStr) !== -1){
			return false;
		}

		/*
			NOTE:
				Try parsing the string.  If it returns a proper object that is NOT null, we're good to go
		*/
		try {
			jsonStr = JSON.parse(jsonStr.trim());
			return typeof jsonStr === 'object' && jsonStr !== null;
		} catch (e) {
			// console.log( `isJSON had an error: ${e.message}` );
			return false;
		}
	}

	/**
	 * Check if a dot notation path exists on an object
	 * without having to do a series of if statements for existence.
	 *
	 * @param {object} obj object to find the path on
	 * @param {string} path the path of the value on the object
	 * @param {any} defaultValue default value to use if the path doesn't exist
	 */
	JSON.getPath = function(obj, path, defaultValue){
		if(typeof obj === 'object' && obj !== null){
			var returnObj = obj,
				pathParts = path.split('.'),
				len = pathParts.length,
				i;

			for(i = 0;i < len;i++){
				try {
					returnObj = returnObj[pathParts[i]];
				}
				catch(e){
					returnObj = undefined;
				}

				if(returnObj === undefined){
					returnObj = defaultValue;
					break;
				}
			}

			return returnObj;
		}
		else {
			return defaultValue;
		}
	};

/* END: JSON */

/* BEGIN: Function */

	Function.prototype.After = function(ms,args,sc){
		var fn,_tmo,_controls,_fn;

		fn = this;
		_fn = function(){
			return fn.apply(_controls.getScope(),_controls.getArgs());
		};
		// Extended methods for controlling the execution
		return _controls = ({
			start : function(){
				_tmo = setTimeout(_fn,ms);
				return this;
			},
			cancel : function(){
				clearTimeout(this.getInstance());
				return this;
			},
			setArgs : function(a){
				args = a;
				return this;
			},
			getArgs : function(){
				return args || [];
			},
			getInstance : function(){
				return _tmo;
			},
			getScope : function(){
				return sc || window;
			},
			setScope : function(s){
				sc = s || window;
				return this;
			},
			exec : function(){
				return _fn();
			},
			setDelay : function(t){
				// Set timing
				ms = t;
				// Kill off current timeout and restart it within new timing
				return this.cancel().start();
			}
		}).start();
	};

	Function.prototype.Every = function(ms,args,sc,maxCnt){
		var fn,_int,_cnt,_paused,_running,_controls,_fn;
		fn = this;
		_cnt = 0;
		_paused = false;
		_running = false;
		_fn = function(frc){
			// Make sure it's not paused or force it
			if(!_controls.isPaused() || frc){
				// Increment the execution count
				++_cnt;
				// Add an argument containing info on this execution - use slice() to clone
				var _args = _controls.getArgs().slice(0);
					_args.push({_int:_controls.getInstance(),_cnt:_controls.getCount()});
				// Execute
				var _res = fn.apply(_controls.getScope(),_args);
				// Determine if it should stop
				(_controls.getMaxCount() && _controls.getCount() >= _controls.getMaxCount()) && _controls.cancel();

				return _res;
			}

			return "Execution paused";
		};
		// Extended methods for controlling the execution
		return _controls = ({
			start : function(){
				if(!this.isRunning()){
					_running = true;
					_int = setInterval(_fn,ms);
				}
				return this;
			},
			cancel : function(){
				_running = false;
				clearInterval(this.getInstance());
				return this;
			},
			pause : function(){
				_paused = true;
				return this;
			},
			play : function(){
				_paused = false;
				return this;
			},
			restart : function(){
				// Reset execution count
				_cnt = 0;
				// Start new interval (do this in case the max was already reached and it's not currently running)
				return this.cancel().start();
			},
			isRunning : function(){
				return _running;
			},
			isPaused : function(){
				return _paused;
			},
			setArgs : function(a){
				args = a;
				return this;
			},
			getArgs : function(){
				return args || [];
			},
			getInstance : function(){
				return _int;
			},
			getCount : function(){
				return _cnt;
			},
			getMaxCount : function(){
				return maxCnt;
			},
			setMaxCount : function(cnt){
				maxCnt = cnt;
				return this;
			},
			getScope : function(){
				return sc || window;
			},
			setScope : function(s){
				sc = s || window;
				return this;
			},
			exec : function(){
				return _fn(true);
			},
			setDelay : function(t){
				// Set timing
				ms = t;
				// Kill off current interval and restart it within new timing
				return this.cancel().start();
			}
		}).start();
	};

	Function.prototype.getParts = function(){
		var fn = this,
			content = fn.toString(),
			args = content.split("{")[0].split("(")[1].split(")")[0].trim() || "args",
			name = content.split("function")[1].split("(")[0].trim();

		// Parse out the body/content of the function to be compiled later
		content = content.split("{").slice(1).join("{");
		content = content.split("}");
		content = content.slice(0,content.length - 1).join("}");

		return {
			name : name,
			args : args,
			content : content
		};
	};

	Function.prototype.When =  function(logic,args,scope,origFn){
		var fn = origFn || this,
			scope = scope || window || this,
			args = args || [];

		if(logic.apply(scope,args)){
			return fn.apply(scope,args);
		}

		return fn.When.After(50,[logic,args,scope,fn],scope);
	};

/* END: Function */
